import { Badge, Tooltip } from '@simplywallst/ui-core/next';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';
import type { ComponentProps } from 'react';

type Props = {
  companyName: string;
  size?: ComponentProps<typeof Badge>['size'];
};

export const NarrativeSponsorshipBadge = ({ companyName, size }: Props) => {
  return (
    <Tooltip
      placement="top"
      content={
        <p className="m-0 w-x20 text-tiny text-solid">
          This Narrative is sponsored by {companyName}. Simply Wall St received
          a fee to promote it. The views are those of the Sponsor and do not
          reflect Simply Wall St&apos;s opinions.
        </p>
      }
    >
      <button type="button" className="focus-outline rounded-md">
        <Badge
          className="grid grid-cols-[min-content_max-content] items-center gap-x0_25"
          size={size}
          tone="info"
        >
          <InformationSolid className="size-4 fill-current" />
          <span>Sponsored</span>
          <span className="sr-only"> content by {companyName}</span>
        </Badge>
      </button>
    </Tooltip>
  );
};
